(function(){
  function $(i){return document.getElementById(i)}
  function esc(s){return String(s).replace(/[&<>"]/g,function(m){return{'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;'}[m]})}
  function dh(c){return Math.round(c/100).toLocaleString('fr-FR')+' DH'}
  var root=(window.Shopify&&Shopify.routes&&Shopify.routes.root)||'/';
  var SHIP=3500;

  function openD(id){closeAll();$(id).classList.add('open');$(id).setAttribute('aria-hidden','false');$('scrim').classList.add('on')}
  function closeAll(){['menu','cart'].forEach(function(i){var e=$(i);if(e){e.classList.remove('open');e.setAttribute('aria-hidden','true')}});var s=$('scrim');if(s)s.classList.remove('on')}
  window.wsCloseAll=closeAll;

  var last=null,msg='';
  function lineHTML(it){
    var fr=String(it.product_title).split(' (Frame ')[1];var n={d:it.product_title,s:fr?'Frame '+fr.replace(')',''):'Accessoire'};
    return '<div class="cline"><div class="ci">'+(it.image?'<img src="'+it.image+(it.image.indexOf('?')>-1?'&':'?')+'width=200" alt="">':'')+'</div><div><div class="t">'+esc(n.d)+'</div><div class="v">'+esc(n.s)+'</div><div class="qty"><button data-q="'+it.key+'" data-n="'+(it.quantity-1)+'" aria-label="Retirer un">−</button><span>'+it.quantity+'</span><button data-q="'+it.key+'" data-n="'+(it.quantity+1)+'" aria-label="Ajouter un">+</button></div>'+(msg&&msg===it.key?'<div class="v">Quantité maximale disponible</div>':'')+'<button class="rm" data-q="'+it.key+'" data-n="0">Supprimer</button></div><div style="font-size:14px">'+dh(it.final_line_price)+'</div></div>'
  }
  function render(c){
    last=c;var cnt=$('cnt');if(cnt){cnt.textContent=c.item_count;cnt.hidden=!c.item_count}
    var body=$('cartBody'),foot=$('cartFoot'),page=$('cartPage');
    var empty='<div class="empty"><p class="lead">Ton panier est vide.</p><a class="btn ghost" href="'+root+'collections/all">Voir la collection</a></div>';
    var lines=c.items.map(lineHTML).join('');
    var tot='<div class="trow"><span>Sous-total</span><span>'+dh(c.total_price)+'</span></div><div class="trow"><span>Livraison</span><span>'+dh(SHIP)+'</span></div><div class="trow big"><span>Total à payer à la livraison</span><span>'+dh(c.total_price+SHIP)+'</span></div><div style="font-size:12px;color:var(--ok);text-align:center">✓ Paiement à la livraison · ✓ Confirmation par appel</div><a class="btn" href="'+root+'checkout">Commander</a><div style="font-size:11px;color:var(--ink2);text-align:center">Bracelets vendus sans capteur</div>';
    if(body){body.innerHTML=c.item_count?lines:empty;foot.innerHTML=c.item_count?tot:''}
    if(page){page.innerHTML=c.item_count?lines+'<div class="cfoot" style="padding:16px 0">'+tot+'</div>':empty}
  }
  function load(){return fetch(root+'cart.js',{headers:{Accept:'application/json'}}).then(function(r){return r.json()}).then(render)}
  function change(key,q){
    msg='';
    return fetch(root+'cart/change.js',{method:'POST',headers:{'Content-Type':'application/json',Accept:'application/json'},body:JSON.stringify({id:key,quantity:q})})
      .then(function(r){return r.json().then(function(j){return{ok:r.ok,j:j}})})
      .then(function(x){
        if(!x.ok){msg=key;return load()}
        var it=(x.j.items||[]).filter(function(i){return i.key===key})[0];
        if(it&&it.quantity<q)msg=key;
        render(x.j);
      });
  }
  function add(id,btn){
    var er=$('addErr');if(er)er.textContent='';
    if(btn)btn.disabled=true;
    fetch(root+'cart/add.js',{method:'POST',headers:{'Content-Type':'application/json',Accept:'application/json'},body:JSON.stringify({items:[{id:Number(id),quantity:1}]})})
      .then(function(r){return r.json().then(function(j){return{ok:r.ok,j:j}})})
      .then(function(x){
        if(btn)btn.disabled=false;
        if(!x.ok){if(er)er.textContent='Tu as déjà la quantité maximale disponible de ce bracelet dans ton panier.';return}
        load().then(function(){openD('cart')});
      }).catch(function(){if(btn)btn.disabled=false});
  }

  function homeFilter(k){
    document.querySelectorAll('#hf button').forEach(function(b){b.setAttribute('aria-pressed',String(b.dataset.hf===k))});
    document.querySelectorAll('#homeGrid .card').forEach(function(c){
      var ok=k==='all'||(k==='lum'?c.dataset.lum==='1':(c.dataset.g===k&&c.dataset.lum!=='1'));
      c.hidden=!ok;
    });
    document.querySelectorAll('#homeGrid .sep4').forEach(function(s){s.hidden=k!=='all'});
  }
  var cf='all';
  function collFilter(){
    var g=$('collGrid');if(!g)return;
    var cards=[].slice.call(g.querySelectorAll('.card')),n=0;
    cards.forEach(function(c){
      var ok=cf==='all'||(cf==='dispo'?c.dataset.av==='1':cf==='silver'?c.dataset.fr==='silver':cf==='black'?c.dataset.fr==='black':c.dataset.g===cf);
      c.hidden=!ok;if(ok)n++;
    });
    var so=($('sortSel')||{}).value||'rec';
    var sorted=cards.slice();
    if(so==='asc')sorted.sort(function(a,b){return a.dataset.price-b.dataset.price});
    else if(so==='desc')sorted.sort(function(a,b){return b.dataset.price-a.dataset.price});
    else if(so==='dispo')sorted.sort(function(a,b){return (b.dataset.av==='1')-(a.dataset.av==='1')});
    if(so!=='rec')sorted.forEach(function(c){g.appendChild(c)});
    g.querySelectorAll('.sep4').forEach(function(s){s.hidden=!(cf==='all'&&so==='rec')});
    var cn=$('collN');if(cn)cn.textContent=n+' article'+(n>1?'s':'');
    var em=$('collEmpty');if(em)em.hidden=n>0;
  }

  function dotsFor(track,dots){
    if(!track||!dots)return;
    track.addEventListener('scroll',function(){var k=Math.round(track.scrollLeft/track.clientWidth);var d=dots.children;for(var j=0;j<d.length;j++)d[j].classList.toggle('on',j===k)},{passive:true});
  }
  function initHero(){
    var hs=$('hs'),hd=$('hdots');if(!hs)return;
    var n=hs.children.length;if(!n){hd.remove();return}
    hd.innerHTML=Array.apply(null,Array(n)).map(function(_,k){return '<i'+(k?'':' class="on"')+'></i>'}).join('');
    dotsFor(hs,hd);
    if(window.matchMedia&&matchMedia('(prefers-reduced-motion: reduce)').matches)return;
    setInterval(function(){var k=Math.round(hs.scrollLeft/hs.clientWidth)+1;if(k>=n)k=0;hs.scrollTo({left:k*hs.clientWidth,behavior:'smooth'})},3800);
  }

  function reveal(){
    var els=document.querySelectorAll('.rv,.card');
    if(!('IntersectionObserver' in window)){els.forEach(function(e){e.classList.add('in')});return}
    var io=new IntersectionObserver(function(es){es.forEach(function(e){if(e.isIntersecting){e.target.classList.add('in');io.unobserve(e.target)}})},{rootMargin:'0px 0px -40px 0px'});
    els.forEach(function(e){if(e.classList.contains('card'))e.classList.add('rv');io.observe(e)});
  }

  document.addEventListener('click',function(e){
    var z=e.target.closest('.slide img');if(z){$('lbImg').src=z.src;$('lb').classList.add('on');return}
    var t=e.target.closest('[data-add],[data-q],[data-hf],[data-f],[data-close]');
    if(!t)return;
    if(t.hasAttribute('data-close')){closeAll();return}
    if(t.hasAttribute('data-hf')){homeFilter(t.dataset.hf);return}
    if(t.hasAttribute('data-f')){cf=t.dataset.f;document.querySelectorAll('#chips .chip').forEach(function(b){b.setAttribute('aria-pressed',String(b.dataset.f===cf))});collFilter();return}
    if(t.hasAttribute('data-add')){add(t.dataset.add,t);return}
    if(t.hasAttribute('data-q')){change(t.dataset.q,Number(t.dataset.n));return}
  });
  document.addEventListener('change',function(e){if(e.target.id==='sortSel')collFilter()});
  document.addEventListener('keydown',function(e){if(e.key==='Escape'){closeAll();var lb=$('lb');if(lb)lb.classList.remove('on')}});

  function init(){
    $('openMenu').addEventListener('click',function(){openD('menu')});
    $('openCart').addEventListener('click',function(){load();openD('cart')});
    $('scrim').addEventListener('click',closeAll);
    $('lbClose').addEventListener('click',function(){$('lb').classList.remove('on')});
    initHero();dotsFor($('gal'),$('dots'));collFilter();reveal();load();
    var bar=$('bar');
    if(bar){document.body.classList.add('pp');window.addEventListener('scroll',function(){bar.classList.toggle('show',window.scrollY>520)},{passive:true})}
  }
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init);else init();
})();
